import { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { makeRequest } from '../Global/makeRequest';

export const AuthContext = createContext();

const readStoredUser = () => {
  try {
    const value = localStorage.getItem('user');
    return value ? JSON.parse(value) : null;
  } catch (_error) {
    localStorage.removeItem('user');
    return null;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(readStoredUser);

  const logins = useCallback(async (username, pass) => {
    const response = await makeRequest.post('/user/login', { username, pass });
    setCurrentUser(response.data.value);
    return response.data.value;
  }, []);

  const logout = useCallback(async () => {
    try {
      await makeRequest.post('/user/logout');
    } finally {
      setCurrentUser(null);
      localStorage.removeItem('user');
      localStorage.removeItem('currentDate');
      localStorage.removeItem('endDate');
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      localStorage.setItem('user', JSON.stringify(currentUser));
    } else {
      localStorage.removeItem('user');
    }
  }, [currentUser]);

  const value = useMemo(() => ({ currentUser, logins, logout }), [currentUser, logins, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
